import { createContext } from "react";

const TvChannelsContext = createContext();

export default TvChannelsContext;
